import { render, staticRenderFns } from "./MUserList.vue?vue&type=template&id=53c20832&"
import script from "./MUserList.vue?vue&type=script&lang=ts&"
export * from "./MUserList.vue?vue&type=script&lang=ts&"
import style0 from "./MUserList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports